import { useLanguage } from '../contexts/LanguageContext';
import { translations } from '../utils/translations';

export const useTranslation = () => {
  const { currentLanguage } = useLanguage();

  const t = (key) => {
    console.log('Çeviri isteniyor:', key, 'Dil:', currentLanguage);
    const keys = key.split('.');
    let value = translations[currentLanguage];
    
    for (const k of keys) {
      if (value && value[k]) {
        value = value[k];
      } else {
        // Fallback to Uzbek if translation not found
        console.log('Çeviri bulunamadı, Özbekçe fallback kullanılıyor:', key);
        value = translations['uz'];
        for (const k of keys) {
          if (value && value[k]) {
            value = value[k];
          } else {
            console.log('Hiçbir çeviri bulunamadı:', key);
            return key; // Return key if no translation found
          }
        }
        break;
      }
    }
    
    console.log('Çeviri sonucu:', key, '->', value);
    return value || key;
  };

  return { t };
};